const rewardTypes = [
    { label: 'Avatar', value: 'avatar' },
    { label: 'Coins', value: 'coins' },
    { label: 'Voucher', value: 'consumable' },
];

export default rewardTypes;
